@if (!disabled) {
  <div #scrollbar class="scrollbar">
    <div
      class="scrollbar__content"
      (scroll)="onScroll()"
      [ngStyle]="{
        'max-height': height,
        'padding-top.px': paddingY,
        'padding-right.px': paddingX ? paddingX + (anchorHeight && anchorHeight < 100 ? gap : 0) : anchorHeight && anchorHeight < 100 ? gap : 0,
        'padding-bottom.px': paddingY,
        'padding-left.px': paddingX,
      }"
    >
      <div #scrollbarMain class="scrollbar__main">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </div>
    </div>
    @if (anchorHeight && anchorHeight < 100) {
      <div class="scrollbar__scroll" [ngStyle]="{ 'top.px': paddingY + scrollbarY, 'bottom.px': paddingY + scrollbarY, 'right.px': scrollbarX }" (mousedown)="mouseDown($event)">
        <div class="scrollbar__scroll-inner" (click)="click($event)">
          <div class="scrollbar__anchor" [ngStyle]="{ 'height.%': anchorHeight, 'top.%': anchorPosition }" (mousedown)="startDragging($event)"></div>
        </div>
      </div>
    }
  </div>
} @else {
  <ng-container *ngTemplateOutlet="content"></ng-container>
}

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
